import React from "react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 border-t border-gold-deep/40 py-10 lg:py-14"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
        <div className="flex items-center gap-4">
          <span className="w-10 h-10 border border-gold/60 flex items-center justify-center font-serif text-gold text-xl">
            R
          </span>
          <div>
            <div className="font-serif text-white text-lg">Ryan Best</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold/70 mt-0.5">
              Making Values Profitable
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-6 font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">
          <a href="https://stbl.io" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">
            STBL.io
          </a>
          <span className="text-gold-deep">·</span>
          <a href="https://2connect.ai" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">
            2Connect.AI
          </a>
          <span className="text-gold-deep">·</span>
          <a
            href="https://goldsilvercrypto.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gold transition-colors"
          >
            GoldSilverCrypto
          </a>
        </div>

        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/30">
          © {new Date().getFullYear()} Ryan Best · Highland, UT
        </div>
      </div>
    </footer>
  );
};

export default Footer;
